import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { BaseLayout } from "components/base-layout";
import { Stack } from "components/common/stack";
import { InsuranceRepresentative } from "components/shared/insurance-representative";
import { MainLayout } from "components/shared/main-layout";
import { SupportSidebar } from "components/shared/support-sidebar";
import { useEligibleCoverages } from "data/ss-data-hooks";
import { useFaqs } from "hooks/use-faqs";
import { getQueryParameter, logError } from "utils";

import FAQList from "./faq-list";

const Support = () => {
  const { data, error, isLoading } = useEligibleCoverages();
  const location = useLocation();
  const navigate = useNavigate();

  const openQuestion = getQueryParameter("question");
  const displayedFAQs = useFaqs({
    noUpsell: data?.coverages?.length === 0,
  });

  // We're purposely logging and ignoring errors here.
  // We just hide the one faq dependent on it
  useEffect(() => {
    if (error) {
      logError(`Use get eligible coverages: (${error.message})`);
    }
  }, [error]);

  const BOTTOM_OFFSET_PX = 64;
  const shouldScrollToContact =
    (location.state as { scrollToContactRepresentative?: boolean })
      ?.scrollToContactRepresentative === true;

  useEffect(() => {
    if (!shouldScrollToContact) return;
    const timer = setTimeout(() => {
      const el = document.getElementById("contact-representative");
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const cardBottom = rect.bottom + window.scrollY;
      const top = cardBottom - window.innerHeight + BOTTOM_OFFSET_PX;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
      // Clear state so back button and future visits don't re-trigger
      if (
        (location.state as { scrollToContactRepresentative?: boolean })
          ?.scrollToContactRepresentative
      ) {
        navigate(location.pathname + location.search, {
          replace: true,
          state: {},
        });
      }
    }, 150);
    return () => clearTimeout(timer);
  }, [
    isLoading,
    shouldScrollToContact,
    location.state,
    location.pathname,
    location.search,
    navigate,
  ]);

  const Sidebar = () => (
    <Stack>
      <SupportSidebar />
      <div id="contact-representative">
        <InsuranceRepresentative />
      </div>
    </Stack>
  );

  return (
    <BaseLayout
      availableNotifications={["HomeServices", "CancellationPayment"]}
    >
      <MainLayout sidebar={<Sidebar />} mainLoading={isLoading}>
        <Stack>
          <FAQList displayedFAQs={displayedFAQs} openQuestion={openQuestion} />
        </Stack>
      </MainLayout>
    </BaseLayout>
  );
};

export default Support;
